// Полоса «подтвердите почту».
//
// Функциональность она не ограничивает: неподтверждённая почта мешает только
// восстановлению доступа, а запирать за этим планировщик — наказывать
// пользователя за то, что письмо ещё не дошло.
import { useState, type ReactElement } from 'react';
import { useI18n, useT } from '../i18n';
import { useAuth } from './AuthProvider';
import { resendVerification } from './api';
import styles from './VerifyBanner.module.css';

export function VerifyBanner(): ReactElement | null {
  const t = useT();
  const { lang } = useI18n();
  const { user } = useAuth();
  const [hidden, setHidden] = useState(false);
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user || user.emailVerified || hidden) return null;

  async function handleResend(): Promise<void> {
    setBusy(true);
    await resendVerification(lang);
    setBusy(false);
    setSent(true);
  }

  return (
    <div className={styles.bar} role="status">
      <span className={styles.text}>{sent ? t('auth.verify.sent') : t('auth.verify.banner')}</span>
      {!sent && (
        <button type="button" className={styles.action} disabled={busy} onClick={handleResend}>
          {t('auth.verify.resend')}
        </button>
      )}
      <button
        type="button"
        className={styles.close}
        onClick={() => setHidden(true)}
        aria-label={t('form.close')}
      >
        ✕
      </button>
    </div>
  );
}
